import React from 'react';
import RevisionPreguntas from '../../components/RevisionPreguntas';

const RevisionPreguntasPage = (props) => (
	<RevisionPreguntas {...props} />
);

export default RevisionPreguntasPage;
